import Debug from '@tiger/debug';
import { useLogger } from '@tiger/logger';
import { Button, DatePicker, Form, Input } from 'antd';
import React, { useState } from 'react';
import { FormItem as FormItemRaw, useForm, withForm } from 'react-antd-formutil';
import Card, { CardButtonWrap } from 'components/Card';
import CurrencyAmount from 'components/CurrencyAmount';
import FieldSelect from 'components/FieldSelect';
import FormItem from 'components/FormItem';
import ConfirmPassword from 'components/forms/Password';
import TelcodePhoneVerify from 'components/forms/TelcodePhoneVerify';
import TelPhone from 'components/forms/TelPhone';
import Loading from 'components/Loading';
import LoadMore from 'components/LoadMore';
import Modal, { openNativeModal, useAlertModal, useConfirmModal } from 'components/Modal';
import ProgressBar from 'components/ProgressBar';
import Steps from 'components/Steps';
import TabNav from 'components/TabNav';
import Toast from 'components/Toast';
import VerifyCodeSend from 'components/VerifyCodeSend';
import require2FA from 'utils/require2FA';
import { getCurrencyInfo } from 'utils/util';
import './style.scss';

const steps = [{ title: '安全' }, { title: '身份' }, { title: '完成' }];

const Demo: React.FC = () => {
    const $formutil = useForm();
    const [activeIndex, setActiveIndex] = useState(0);
    const { open: openAlertModal } = useAlertModal();
    const { open: openConfirmModal } = useConfirmModal();
    const logger = useLogger('modules/Demo');
    const [currencyList] = useState(() => {
        return ['USD'].map(currency => {
            const item = getCurrencyInfo(currency);

            return {
                label: item.name,
                icon: item.icon,
                value: currency
            };
        });
    });
    const handleFinish = () => {
        logger.log($formutil.$params);
    };
    const openModal = () => {
        Modal.open({
            component: props => (
                <div>
                    <Button type="primary" onClick={props.close}>
                        test
                    </Button>
                </div>
            ),
            closable: true
        }).result.catch(() => {});
    };
    const open2FA = () => {
        require2FA()
            .then(val => {
                logger.log(val);
            })
            .catch(e => {
                Toast.show(e);
            });
    };
    const handleAlertModal = () => {
        openAlertModal({
            content: 2312321321321,
            title: '312321312231'
        });
    };
    const handleConfirmModal = () => {
        openConfirmModal({
            content: 2312321321321,
            title: '312321312231'
        });
    };
    const handleNativeModal = () => {
        openNativeModal({
            component: (
                <p
                    style={{
                        height: 300
                    }}>
                    dasdasdsadsadas
                </p>
            ),
            maskClosable: true
        }).result.catch(() => {});
    };
    const handleShowToast = () => {
        Toast.loading(true, 'loading...');

        setTimeout(() => {
            Toast.loading(false);
        }, 2000);
    };

    return (
        <Card page className="demo-page">
            <Card form>
                <Loading />
                <ProgressBar steps={steps} selectedIndex={1} />
                <ProgressBar steps={steps} selectedIndex={2} />
                <ProgressBar steps={steps} selectedIndex={3} />
                <TabNav
                    navs={[{ name: '手机号' }, { name: '邮箱' }, { name: '老虎令牌' }]}
                    mode="lite"
                    className="my-3"
                    activeIndex={activeIndex}
                    onClick={i => setActiveIndex(i)}
                />
                <TabNav
                    navs={[{ name: '手机号' }, { name: '邮箱' }, { name: '老虎令牌' }]}
                    className="my-3"
                    activeIndex={activeIndex}
                    onClick={i => setActiveIndex(i)}
                />
                <Steps steps={steps} />
                <Button onClick={openModal} type="primary" className="mb-3">
                    modal test
                </Button>
                <Button onClick={open2FA} type="primary" className="mb-3">
                    2fa test
                </Button>
                <Button onClick={handleAlertModal} type="primary" className="mb-3">
                    open alert modal
                </Button>
                <Button onClick={handleConfirmModal} type="primary" className="mb-3">
                    open confirm modal
                </Button>
                <Button onClick={handleNativeModal} type="primary" className="mb-3">
                    open native modal
                </Button>
                <Button onClick={handleShowToast}>show toast</Button>
                <Form layout="vertical" colon={false} onFinish={handleFinish}>
                    <FormItemRaw label="有边框输入框(适用登录)">
                        <Input placeholder="input" />
                    </FormItemRaw>
                    <FormItem label="无边框输入框">
                        <Input placeholder="input" />
                    </FormItem>
                    <FormItem name="datePicker" label="日期选择器">
                        <DatePicker className="w-100" allowClear={false} />
                    </FormItem>
                    <FormItem label="disabled">
                        <Input disabled placeholder="input" value="31321" />
                    </FormItem>
                    <VerifyCodeSend process="modify_phone" name="code1" />
                    <ConfirmPassword />

                    <TelPhone line />
                    <TelcodePhoneVerify process="modify_phone" />
                    <CurrencyAmount
                        currencyList={currencyList}
                        inputConfig={{
                            name: 'amount',
                            placeholder: '0.00',
                            checker: value => {
                                if (value > 100) {
                                    return '不能超过100';
                                }

                                return true;
                            }
                        }}
                        selectConfig={{
                            disabled: currencyList.length <= 1,
                            name: 'currency',
                            $defaultValue: 'USD',
                            showIcon: false
                        }}
                    />
                    <FormItem className="mt-3" name="reason" required label="FieldSelect component">
                        <FieldSelect
                            data={['test', 'tst', 'tsdast', 'ts'].map((item, index) => ({
                                label: item,
                                value: `${index}`
                            }))}
                            placeholder="选一个"
                        />
                    </FormItem>

                    <CardButtonWrap className="mt-5">
                        <Button block type="default" size="large">
                            Cancel
                        </Button>
                        <Button htmlType="submit" block type="primary" size="large">
                            Submit
                        </Button>
                    </CardButtonWrap>
                    <Debug data={$formutil.$params} />
                </Form>
                <LoadMore
                    isAuto
                    error={null}
                    loading={false}
                    showMoreBtn
                    isEnd={false}
                    throttleTime={500}
                    onScrollToBottom={() => {
                        logger.log('load more');
                    }}
                />
            </Card>
        </Card>
    );
};

export default withForm(Demo);
